$(function() {

	$(window).scroll(function() {
		if ($(window).scrollTop() >= 70) {
			$('header.header').addClass('is-fixed');
		} else {
			$('header.header').removeClass('is-fixed');
		}
	});

	$('.js-trigger-cart-note').on('click', function(e) {
		e.preventDefault();
		$(this).parent().parent().toggleClass('hide-note');
	});

	$('.show-cart').on('click', function(e) {
		e.preventDefault();
		$('body').addClass('js-show-cart');
	});

	$('.js-close-cart').on('click', function(e) {
		e.preventDefault();
		$('body').removeClass('js-show-cart');
	});

	if (window.location.hash && window.location.hash == '#show-cart') {
		$('body').addClass('js-show-cart');
	}

	$('#CartNote').on('blur', function() {
		CartJS.setNote($(this).val());
	});

	$(".innerscroll").on('click', function(e) {
		e.preventDefault();
		var id = $(this).attr("href");
		$('html, body').animate({
			scrollTop: $(id).offset().top - (40)
		}, 1500);
	});


	$('.js-add-to-bag').on('click', function(e) {
		e.preventDefault();
		var the_id = $(this).data('product-id');
		console.log(the_id);
		if (the_id) {
			CartJS.addItem(the_id, 1, {}, {
				"success": function(data, textStatus, jqXHR) {
					$('body').addClass('js-show-cart');
				}
			});
		}

	});

});